<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
  >
    <promo-form ref="form" v-model="form" :input-errors="inputErrors" @save="create"/>
  </crud-create>
</template>

<script>

import PromoProvider from "../../../../providers/PromoProvider";

import {CrudCreate, ClientError} from '@dracul/common-frontend'

import PromoForm from "../../../../forms/PromoForm";


export default {
  name: "PromoCreate",

  components: {PromoForm, CrudCreate},

  props: {
    open: {type: Boolean, default: true}
  },

  data() {
    return {
      title: 'delivery.promo.creating',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      form: {
        name: '',
        price: null,
        active: false,
        mode: [],
        calendar: null,
        image: null,
        config: [],
      }
    }
  },

  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true
        PromoProvider.createPromo(this.form).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createPromo)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }

  },
}
</script>

<style scoped>

</style>

